import { render } from "./ProfilePhrozenVerified.vue?vue&type=template&id=4c6b9c10"
import script from "./ProfilePhrozenVerified.vue?vue&type=script&lang=js"
export * from "./ProfilePhrozenVerified.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__